import { useState } from "react";

const Newsletter = () => {

    const [email, setEmail] = useState('')

    const checkEnter = (key) => {
        if(key === 'Enter'){
            console.log(email)
        }
    }

    const handleSubmit = () => {
        fetch(`https://ipj-api.vercel.app/api/emails`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'POST',                                                              
            body: JSON.stringify( { email: email} )  
        })
        .then(res => res.json())
        .then(data => {
            alert(data.message);
            setEmail('')
        })
    }

    return (
        <div className="newsletter" id='newsletter'>
            <h2>Se mantenha informado</h2>
            <span>Cadastre-se em nossa newsletter</span>
            <div className="input-div">
                <input type="text" placeholder="Digite seu email aqui" value={email} onKeyDown={(e) => checkEnter(e.key)} onChange={(e) => setEmail(e.target.value)}/>
                <div onClick={() => handleSubmit()}>Inscrever</div>
            </div>
        </div>
     );
}
 
export default Newsletter;